const setAudienceId = (state, payload) => {
  state.audienceId = payload
}

const setQuestionerName = (state, payload) => {
  state.setQuestionerName = payload
}

const setAudience = (state, payload) => {
  state.audience = payload
}

const setOffsetTime = (state, payload) => {
  state.offsetTime = payload
}

export default {
  setAudienceId,
  setQuestionerName,
  setAudience,
  setOffsetTime,
}
